import { VLibras } from 'govbr.frontend.policy/components';
import messages from 'govbr.frontend.policy/messages/skiplinks';
import { useIntl } from 'react-intl';

const SkipLinks = () => {
  const intl = useIntl();

  const handleNavigationClick = (e) => {
    e.preventDefault();
    document.getElementById('navigation').focus();
    document.getElementById('navigation').scrollIntoView();
  };

  const handleSearchClick = (e) => {
    e.preventDefault();
    document.getElementById('header-search-widget').focus();
    document.getElementById('header-search-widget').scrollIntoView();
  };

  const handleEscSkiplink = (e) => {
    e = e || window.event;
    if (e.keyCode === 27) {
      const links = document.querySelectorAll('.br-skiplink .br-item');
      for (var i = 0; i < links.length; i++) {
        links.item(i).blur();
      }
    }
  };

  return (
    <>
      <nav
        className="br-skiplink full"
        aria-label={intl.formatMessage(messages.skiplinks)}
      >
        <a className="br-item" href="#view" onKeyDown={handleEscSkiplink}>
          {intl.formatMessage(messages.skiplinkMainContent)}
        </a>
        <a
          className="br-item"
          href="#navigation"
          onClick={handleNavigationClick}
          onKeyDown={handleEscSkiplink}
        >
          {intl.formatMessage(messages.skiplinkNavigation)}
        </a>
        <a
          className="br-item"
          href="#header-search-widget"
          onClick={handleSearchClick}
          onKeyDown={handleEscSkiplink}
        >
          {intl.formatMessage(messages.skiplinkSearchbox)}
        </a>
        <a className="br-item" href="#footer" onKeyDown={handleEscSkiplink}>
          {intl.formatMessage(messages.skiplinkFooter)}
        </a>
      </nav>
      <VLibras />
    </>
  );
};

export default SkipLinks;
